export const sliderGalleryV1 = {
  elements: Array.from(
    document.querySelectorAll(".slider-gallery-v1 .swiper-container")
  ),
  details: (el) => ({
    // Optional parameters
    cssMode: true,
    loop: true,
    slidesPerView: 6,
    spaceBetween: 0,
    speed: 800,
    threshold: 10,
    centeredSlides: false,
    // longSwipesRatio: 2,
    resistance: false,

    // Disable preloading of all images
    // preloadImages: false,
    // Enable lazy loading
    lazy: true,

    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },

    // If we need pagination
    pagination: {
      el: el.querySelector(".swiper-pagination"),
    },
    // Navigation arrows
    navigation: {
      nextEl: el.querySelector(".swiper-button-next"),
      prevEl: el.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      1023: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
  }),
};
